module.exports = __webpack_public_path__ + "img/back_office.23c6e1ed.gif";